var map = {
	"./bonga-mkhize.webp": 7430,
	"./dinesh-singh.webp": 6487,
	"./elcano-wilson.webp": 5395,
	"./fazlin-ally.webp": 8055,
	"./jose-romero.webp": 3914,
	"./muhammed-daya.webp": 5406,
	"./richard-brews.webp": 9129,
	"./salome-kgoale.webp": 9809,
	"./sean-forrester.webp": 2814
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2553;